


















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getPrograms, deleteProgram } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import get from 'lodash/get';
import Program from '../models/Program';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import moment from 'moment';
import Datatable from '@/components/Datatable.vue';
import Boolean from '@/components/Boolean.vue';
import cloneDeep from 'lodash/cloneDeep';
import {
    formatProgramStateStatus,
    getProgramStateStatusColor,
    getStatusItems,
} from '@/data/programStateStatus';
import { fetchPromotors } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import AuthModule from '@/store/AuthModule';
import taxSystems, { getTaxSystemValue } from '@/data/taxSystems';

// @ts-ignore
import localeDatePicker from 'ant-design-vue/lib/date-picker/locale/fr_FR';
import { DatePicker } from 'ant-design-vue';
const { RangePicker } = DatePicker;
import cities from '@/data/cities';

@Component({
    components: {
        Datatable,
        Boolean,
        FilterComponent,
        RangePicker,
    },
    filters: {
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatDepartment: (value: string) => {
            if (value.startsWith('97')) {
                return value.slice(0, 3);
            }
            return value.slice(0, 2);
        },
        formatTaxSystem: (value: string[]) => {
            let state = '';
            value.forEach(el => {
                if (value.indexOf(el) !== 0) {
                    state += ', ';
                }
                state += getTaxSystemValue(el);
            });
            return state;
        },
        formatProgramStateStatus,
        displayMandat: (value: number) => {
            if (typeof value == 'undefined') {
                return 'MR';
            } else {
                return value;
            }
        },
    },
})
export default class Programs extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 50,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };

    mandateFilter: string | undefined | null = null;
    fluxModel: string | undefined | null = null;
    statusProgramme: string | undefined | null = null;
    taxProgram: string | undefined | null = null;

    moment = moment;
    dateDeliveryModel: [moment.Moment | null, moment.Moment | null] | null = null;
    localeDatePicker = localeDatePicker;

    meta: MetaDatatable = cloneDeep(this.defaultMeta);

    columns: HeaderDatatable[] = [
        {
            title: 'Nom Programme',
            dataIndex: 'name',
            sorter: true,
            scopedSlots: { customRender: 'name' },
        },
        {
            title: 'Taux d\'honoraire (%)',
            dataIndex: 'duty_free_fee',
            sorter: true,
            scopedSlots: { customRender: 'duty_free_fee' },
        },
        {
            title: 'Vendeur / Promoteur',
            dataIndex: 'promoter',
            sorter: true,
            scopedSlots: { customRender: 'promoter' },
        },
        {
            title: 'N° Mandat',
            dataIndex: 'mandat.num_mandat',
            sorter: true,
            scopedSlots: { customRender: 'mandat' },
        },
        {
            title: 'Dépt.',
            dataIndex: 'address.postal_code',
            sorter: true,
            scopedSlots: { customRender: 'department' },
        },
        {
            title: 'Ville',
            dataIndex: 'address.city',
            sorter: true,
        },
        {
            title: 'Statut',
            dataIndex: 'status',
            sorter: true,
            scopedSlots: { customRender: 'programStateStatus' },
        },
        {
            title: 'Espace Partenaire',
            dataIndex: 'promoter.api_available',
            sorter: true,
            scopedSlots: { customRender: 'boolean' },
            align: 'center',
        },
        {
            title: 'Flux Connecté',
            dataIndex: 'promoter.api_connected',
            sorter: true,
            scopedSlots: { customRender: 'boolean' },
            align: 'center',
        },
        {
            title: 'Opérateur',
            dataIndex: 'updated_by',
            scopedSlots: { customRender: 'operator' },
            sorter: true,
        },
        {
            title: 'MAJ Stock',
            dataIndex: 'stock_updated_at',
            scopedSlots: { customRender: 'date' },
            sorter: true,
        },
        {
            title: 'Livraison',
            dataIndex: 'date_delivery',
            sorter: true,
            scopedSlots: { customRender: 'date' },
        },
        {
            title: 'Fiscalité',
            dataIndex: 'tax_system',
            scopedSlots: { customRender: 'taxSystem' },
            sorter: true,
        },
        {
            title: 'Création',
            dataIndex: 'created_at',
            scopedSlots: { customRender: 'date' },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: { customRender: 'actions' },
            fixed: 'right',
        },
    ];

    // Initialisés à null pour être réactifs (vue-class-component ignore les champs à undefined),
    // puis remis à undefined dans created() pour que les a-select affichent leur placeholder
    promotorFilter: number | undefined | null = null;
    cityFilter: string | undefined | null = null;

    // Tracks the fetch round-trip so background updates from stale fetches are discarded
    private fetchId = 0;

    // 'available' par défaut : seuls les programmes diffusés sont chargés
    availability: 'available' | 'all' = 'available';

    onAvailabilityChange(e: any) {
        this.availability = e.target.value;
        if (this.meta.page !== 1) {
            this.meta.page = 1; // the meta watcher triggers the fetch
        } else {
            (this.$refs.datatable as any).refresh();
        }
    }

    // Search by program name (default) or by exact program ID
    searchMode: 'name' | 'id' = 'name';

    onSearchModeChange(e: any) {
        this.searchMode = e.target.value;
        if (!this.meta.search) return;
        if (this.meta.page !== 1) {
            this.meta.page = 1;
        } else {
            (this.$refs.datatable as any).refresh();
        }
    }

    async fetch(meta: MetaDatatable) {
        const QUICK_SIZE = 25;
        const search = meta.search ? String(meta.search).trim() : null;
        const isIdSearch = this.searchMode === 'id' && !!search;
        // availability is always applied, so the search stays within Disponible / Tous
        const filters: any = { ...(meta.filters || {}), availability: this.availability };
        if (isIdSearch) {
            filters.programIdExact = search;
        }
        const baseMeta = {
            ...meta,
            page: meta.page - 1,
            search: isIdSearch ? null : search,
            filters,
        };

        // Progressive mode: only useful when fetching more than QUICK_SIZE and on page 1
        if (meta.perPage > QUICK_SIZE && meta.page === 1) {
            const currentFetchId = ++this.fetchId;

            const quick = getPrograms({ ...baseMeta, perPage: QUICK_SIZE }).then(r => ({
                data: r.data.data,
                meta: {
                    total: r.data.meta.total,
                    // Use the original perPage so pagination counters are correct
                    pages: Math.ceil(r.data.meta.total / meta.perPage),
                },
            }));

            const full = getPrograms(baseMeta).then(r => ({
                data: r.data.data,
                meta: r.data.meta,
            }));

            // Guard the background update against stale fetchId
            const guardedFull = full.then(data => {
                if (currentFetchId !== this.fetchId) throw new Error('stale');
                return data;
            });

            return { quick, full: guardedFull };
        }

        const { data } = await getPrograms(baseMeta);
        return data;
    }

    deleteText = {
        confirm: {
            title: `Suppression du programme`,
            content: `Voulez-vous vraiment supprimer le programme ?`,
        },
        notify: {
            title: 'Programme supprimé',
            content: `Le programme a bien été supprimé`,
        },
    };

    get fetchPromotor() {
        return fetchPromotors;
    }

    get getStatus() {
        return getStatusItems('', AuthModule.roles);
    }

    get getTaxes() {
        return taxSystems;
    }

    onFilterPromotor(value: number | undefined) {
        if (value) {
            this.promotorFilter = value;
            this.meta.filters = { promotor: value };
        } else {
            this.promotorFilter = undefined;
            this.meta.filters = { promotor: undefined };
        }
    }

    onFilterTaxProgram(value: string) {
        if (value) {
            this.taxProgram = value;
            this.meta.filters = { tax_system: [value] };
        } else {
            this.taxProgram = undefined;
            this.meta.filters = { tax_system: undefined };
        }
    }

    onFilterStatusProgram(value: string | undefined) {
        if (value) {
            this.statusProgramme = value;
            this.meta.filters = { statusProgram: value };
        } else {
            this.meta.filters = { statusProgram: null };
            this.statusProgramme = undefined;
        }
    }

    onFilterFlux(value: string | undefined) {
        if (value) {
            this.fluxModel = value;
            this.meta.filters = { api_connected: value };
        } else {
            this.meta.filters = { api_connected: null };
            this.fluxModel = undefined;
        }
    }

    onFilterMandate(value: string | undefined) {
        if (value) {
            this.mandateFilter = value;
            this.meta.filters = { mandate: value };
        } else {
            this.meta.filters = { mandate: null };
            this.mandateFilter = undefined;
        }
    }

    @Watch('meta', { deep: true })
    onMeta() {
        if (this.meta.filters) {
            if (this.meta.filters.promotor) {
                this.promotorFilter = this.meta.filters.promotor;
            }
            if (this.meta.filters.mandate) {
                this.mandateFilter = this.meta.filters.mandate;
            }
            if (this.meta.filters.api_connected) {
                this.fluxModel = this.meta.filters.api_connected;
            }
            if (this.meta.filters.statusProgram) {
                this.statusProgramme = this.meta.filters.statusProgram;
            }
            if (this.meta.filters.tax_system) {
                this.taxProgram = this.meta.filters.tax_system;
            }

            if ((this.meta.filters as any).city) {
                this.cityFilter = (this.meta.filters as any).city;
            } else {
                this.cityFilter = undefined;
            }

            const f: any = this.meta.filters;
            if (f.date_delivery_start && f.date_delivery_end) {
                this.dateDeliveryModel = [
                    moment(f.date_delivery_start, 'YYYY-MM-DD'),
                    moment(f.date_delivery_end, 'YYYY-MM-DD'),
                ];
            } else {
                this.dateDeliveryModel = null;
            }
        }
    }

    @Watch('dateDeliveryModel')
    onDateDeliveryModelChange() {
        const $datatable = this.$refs.datatable as any;
        if ($datatable && $datatable.refresh) $datatable.refresh();
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Program | null;
    }) {
        const program: Program | null = ev.item || null;
        switch (ev.action) {
            case 'show':
                if (program !== null) {
                    this.$router.push({
                        name: 'showProgram',
                        params: { programID: `${program.id}` },
                    });
                }
                break;
            case 'edit':
                if (program !== null) {
                    this.$router.push({
                        name: 'editProgram',
                        params: { id: `${program.id}` },
                    });
                }
                break;
            case 'delete':
                if (program && program.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 50,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deleteProgram(program.id);
                }
                break;
        }
    }

    deleteDialog(program: Program) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(program),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    getProgramStateStatusColor(status: string) {
        return getProgramStateStatusColor(status);
    }

    created() {
        // La liste repart toujours de zéro : on purge l'ancien état sauvegardé par le Datatable
        // (search/filters restaurés sans le mode Nom/ID ni Disponible/Tous -> liste vide)
        try {
            localStorage.removeItem('datatable.programs');
        } catch (e) {
            // stockage indisponible : rien à purger
        }
        this.cityFilter = undefined;
        this.fluxModel = undefined;
        this.mandateFilter = undefined;
        this.promotorFilter = undefined;
        this.statusProgramme = undefined;
        this.taxProgram = undefined;
    }

    async acceptDeleteAlert(program: Program) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: program });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression du programme`,
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    onDateDeliveryFilter(dates: [moment.Moment | null, moment.Moment | null] | null) {
        const filters = this.meta.filters || {};
        if (dates && dates[0] && dates[1]) {
            const start = dates[0].format('YYYY-MM-DD');
            const end = dates[1].format('YYYY-MM-DD');
            this.meta.filters = {
                ...filters,
                date_delivery_start: start,
                date_delivery_end: end,
            };
        } else {
            const { date_delivery_start, date_delivery_end, ...rest } = filters as any;
            this.meta.filters = { ...rest };
            this.dateDeliveryModel = null;
        }
        const $datatable = this.$refs.datatable as any;
        if ($datatable && $datatable.refresh) $datatable.refresh();
    }

    async fetchCities(input: string) {
        if (!input || input.trim().length < 2) return [];
        const { data } = await cities(input.trim());
        return data.map((el: any) => ({
            text: el.nom,
            value: el.nom,
        }));
    }

    onFilterCity(value: string | undefined) {
        if (value) {
            this.cityFilter = value;
            this.meta.filters = {
                ...(this.meta.filters || {}),
                city: value,
            };
        } else {
            this.cityFilter = undefined;
            if (this.meta.filters) {
                const f: any = { ...this.meta.filters };
                delete f.city;
                this.meta.filters = f;
            }
        }
        const $datatable = this.$refs.datatable as any;
        if ($datatable && $datatable.refresh) $datatable.refresh();
    }
}
